// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Container":"Container-3d9x11v5fjkpe7sdqbdzrq7t9vk6uasz3txzqeay2cvd4wvwcsb6589p1bytmrg4bxezm3nt7csm6h2m1g81qxpwk45hk9cnnznsfq","loading":"loading-3pdqhqqc26sjr1wp2hgsrqn9yjb61r5ppw29ns1ha87mru61k5k6dcas7pmdkna1qqdbcjw12q6f1z1qpgpryyd99qup8r66k4mc9jt","pulse":"pulse-38s8ezzceeg1eaadktgxjb86cbbkxnygqkabz2xnh93q465vpxe8gxst2nvs49z2ykycg9yjmqdq96gyw58u5shdz4txfd6d3bcdswv"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Layout/components/Container/Container.module.scss
// module id = 762
// module chunks = 0